import React from 'react';
import { TargetType, FulfillmentGrade } from 'stores/workflowStores/finances/targets/model';
import { DepositType } from 'stores/workflowStores/finances/depositsStore/model';
import { ExtProductType } from 'pages/Accounts/Edit/components/ExternalProducts/model';

import StudyIcon from 'components/Icons/StudyIcon';
import VehicleIcon from 'components/Icons/VehicleIcon';
import TravelIcon from 'components/Icons/TravelIcon';
import WeddingIcon from 'components/Icons/WeddingIcon';
import LivingIcon from 'components/Icons/LivingIcon';
import ConstructionIcon from 'components/Icons/ConstructionIcon';
import DonationIcon from 'components/Icons/DonationIcon';
import CareIcon from 'components/Icons/CareIcon';
import MoneyIcon from 'components/Icons/MoneyIcon';
import AddIcon from 'components/Icons/AddIcon';
import TargetIcon from 'components/Icons/TargetIcon';
import RetirementIcon from 'components/Icons/RetirementIcon';
import DepositSingleIcon from 'components/Icons/DepositSingleIcon';
import DepositRegularIcon from 'components/Icons/DepositRegularIcon';
import LockIcon from 'components/Icons/LockIcon';
import UnlockIcon from 'components/Icons/UnlockIcon';
import Date from 'components/Icons/Date';
import WithdrawalIcon from 'components/Icons/WithdrawalIcon';
import ValuablesIcon from 'components/Icons/ValuablesIcon';
import CompanyIcon from 'components/Icons/CompanyIcon';
import MortageIcon from 'components/Icons/MortageIcon';
import PropertyIcon from 'components/Icons/PropertyIcon';
import RealEstateRentIcon from 'components/Icons/RealEstateRentIcon';
import LoanIcon from 'components/Icons/LoanIcon';
import ConsumerLoanIcon from 'components/Icons/ConsumerLoanIcon';
import RealEstateIcon from 'components/Icons/RealEstateIcon';

import ThumbDown from '@material-ui/icons/ThumbDown';
import ThumbUp from '@material-ui/icons/ThumbUp';
import ThumbsUpDown from '@material-ui/icons/ThumbsUpDown';

export const typeIcon = (
  type: TargetType | DepositType | ExtProductType | 'RESERVE' | 'RESERVE_END' | 'DATE' | 'TARGET' | 'DEPOSIT' | 'WITHDRAWAL',
  color?: string,
) => {
  switch (type) {
    case TargetType.PORTFOLIO_RENT:
      return <RetirementIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.STUDY:
      return <StudyIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.VEHICLE:
      return <VehicleIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.TRAVEL:
      return <TravelIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.WEDDING:
      return <WeddingIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.LIVING:
      return <LivingIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.CONSTRUCTION:
      return <ConstructionIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.CARE:
      return <CareIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.DONATION:
      return <DonationIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.RENT:
      return <MoneyIcon fontSize="inherit" htmlColor={color} />;
    case TargetType.OTHER:
    case 'TARGET':
      return <TargetIcon fontSize="inherit" htmlColor={color} />;
    case DepositType.SINGLE:
    case DepositType.FUTURE:
    case DepositType.FUTURE_SINGLE:
    case 'DEPOSIT':
      return <DepositSingleIcon fontSize="inherit" htmlColor={color} />;
    case DepositType.REGULAR:
    case DepositType.MONTHLY:
    case DepositType.YEARLY:
    case DepositType.REPEAT_EVERY:
    case DepositType.FUTURE_REGULAR:
      return <DepositRegularIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.VALUABLES:
      return <ValuablesIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.COMPANY:
      return <CompanyIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.MORTGAGE:
    case ExtProductType.BUILDING_LOAN:
      return <MortageIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.OTHER_PROPERTY:
      return <PropertyIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.REAL_ESTATE_RENT:
      return <RealEstateRentIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.REAL_ESTATE:
      return <RealEstateIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.OTHER_LOAN:
      return <LoanIcon fontSize="inherit" htmlColor={color} />;
    case ExtProductType.CONSUMER_LOAN:
      return <ConsumerLoanIcon fontSize="inherit" htmlColor={color} />;
    case 'RESERVE':
      return <LockIcon fontSize="inherit" htmlColor={color} />;
    case 'RESERVE_END':
      return <UnlockIcon fontSize="inherit" htmlColor={color} />;
    case 'DATE':
      return <Date fontSize="inherit" htmlColor={color} />;
    case 'WITHDRAWAL':
      return <WithdrawalIcon fontSize="inherit" htmlColor={color} />;
    default:
      return <AddIcon fontSize="inherit" htmlColor={color} />;
  }
};

export const fulfillmentIcon = (grade: FulfillmentGrade) => {
  switch (grade) {
    case FulfillmentGrade.NONE:
      return <ThumbDown fontSize="inherit" />;
    case FulfillmentGrade.PARTIAL:
      return <ThumbsUpDown fontSize="inherit" />;
    case FulfillmentGrade.FULL:
      return <ThumbUp fontSize="inherit" />;
  }
};
